import { render } from "./Wait.vue?vue&type=template&id=64a7ded0"
import script from "./Wait.vue?vue&type=script&lang=js"
export * from "./Wait.vue?vue&type=script&lang=js"

import exportComponent from "/u2/fatih/altTicketNew/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__